$(document).ready(function () {
	"use strict";

	//Получение данных по портфелю
	const portfolioName = window.location.href.split("/").pop();

	let portfolioNameCompare = {}
	if(window.location.host === 'sberbank-insurance.ru' || window.location.host === 'test-sbercloud.sberbank-insurance.ru' ){
		portfolioNameCompare = {
			"egs-balanced": 1,
			"egs-moderately": 3,
			"egs-high": 2,
			"momentum": 4,
			"egs-low-regular": 7,
			"egs-balanced-regular": 6,
			"income-formula": 151,
			"investments-in-yuan": 474,
			"currency-perspective": 447,
		};
	}
	else {
		portfolioNameCompare = {
			"egs-balanced": 1,
			"egs-moderately": 3,
			"egs-high": 2,
			"momentum": 4,
			"egs-low-regular": 7,
			"egs-balanced-regular": 6,
			"income-formula": 61,
			"investments-in-yuan": 61,
			"currency-perspective": 447,
		}
	};

	if (portfolioName === 'income-formula' || portfolioName === 'investments-in-yuan'){
		console.log(portfolioName)
		$.ajax({
			type: "GET",
			url: `/managed-capital/get-portfolio-issuers?portfolio=${portfolioNameCompare[portfolioName]}`,
			success: function (params) {
				if (portfolioNameCompare[portfolioName] !== portfolioNameCompare["income-formula"] || portfolioNameCompare[portfolioName] !== portfolioNameCompare["investments-in-yuan"]) {
					return;
				};
				const briefcaseNode = $('.js-briefcase');
				const sphereNames = [];
				const spherePercent = [];
				// if(portfolioName === 'investments-in-yuan'){
				// 	params = [
				// 		{
				// 			shortname: 'Инструменты денежного рынка',
				// 			name: 'Инструменты денежного рынка',
				// 			fact: '80',
				// 		},
				// 		{
				// 			shortname: 'Облигации в юанях',
				// 			name: 'Облигации в юанях',
				// 			fact: '10',
				// 		},
				// 		{
				// 			shortname: 'Фонд облигации в юанях',
				// 			name: 'Фонд облигации в юанях',
				// 			fact: '10',
				// 		},
				// 	]
				// }
				// if(portfolioName === 'currency-perspective'){
				// 	params = [
				// 		{
				// 			shortname: 'Инструменты денежного рынка',
				// 			name: 'Инструменты денежного рынка',
				// 			fact: '80',
				// 		},
				// 		{
				// 			shortname: 'Корпоративные облигации в $',
				// 			name: 'Корпоративные облигации в $',
				// 			fact: '10',
				// 		},
				// 		{
				// 			shortname: 'Еврооблигации МинФина РФ в $',
				// 			name: 'Еврооблигации МинФина РФ в $',
				// 			fact: '10',
				// 		}
				// 	]
				// }
				params.map(param => {
					if(param.shortname === 'Минфин РФ'){
						sphereNames.push('Денежный рынок')
					}
					else {
						sphereNames.push(param.shortname)
					}
					spherePercent.push(param.fact)
				})
				addChart(sphereNames, spherePercent);
			},
			errors: function (errors) {
				console.log(errors);
			},
		});
	}

	//Добавляет круговую диграмму
	function addChart(sphereNames, spherePercent) {
		//Круговая диаграмма
		let selectedDatasetIndex = undefined;
		let selectedIndex = undefined;
		const ctx = document.getElementById("myChart").getContext("2d");

		var gradient1 = ctx.createLinearGradient(1, 0, 0, 175);
		if (portfolioName === "investments-in-yuan") {
			gradient1.addColorStop(1, 'rgba(43, 252, 43, 1)');
		}
		else {
			gradient1.addColorStop(1, 'rgba(255, 255, 104, 1)');
		};
		gradient1.addColorStop(0, 'rgba(43, 252, 43, 1)'); // Don't touch

		var gradient2 = ctx.createLinearGradient(0, 0, 1, 230);
		gradient2.addColorStop(1, 'rgba(26, 200, 255, 1)');
		gradient2.addColorStop(0, 'rgba(108, 255, 246, 1)');
		gradient2.addColorStop(0, 'rgba(255, 255, 255, 1)');

		var gradient3 = ctx.createLinearGradient(1, 1, 0, 175);
		gradient3.addColorStop(1, 'rgba(255, 208, 87, 1)');
		gradient3.addColorStop(0, 'rgba(255, 121, 46, 1)');
		// gradient3.addColorStop(0, 'rgba(255, 255, 255, 1)');

		var gradient4 = ctx.createLinearGradient(0, 1, 1, 175);
		gradient4.addColorStop(0, 'rgba(138, 255, 146, 1)');
		gradient4.addColorStop(1, 'rgba(97, 255, 57, 1)');
		// gradient4.addColorStop(1, 'rgba(255, 255, 255, 1)');

		var gradient5 = ctx.createLinearGradient(1, 0, 1, 175);
		gradient5.addColorStop(0, 'rgba(135, 218, 255, 1)');
		gradient5.addColorStop(1, 'rgba(91, 157, 255, 1)');
		// gradient5.addColorStop(1, 'rgba(255, 255, 255, 1)');

		var gradient6 = ctx.createLinearGradient(1, 0, 0, 175);
		gradient6.addColorStop(0, 'rgba(250, 237, 13, 1)');
		gradient6.addColorStop(1, 'rgba(255, 175, 82, 1)'); // Don't touch
		// gradient6.addColorStop(0, 'rgba(255, 255, 255, 1)');

		const myChart = new Chart(ctx, {
			type: "doughnut",
			data: {
				// labels: ['Инструменты денежного рынка РЕПО с ЦК', 'Биржевое золото', 'БПИФ на акции (SBMX)', 'БПИФ на корп. облигации (SBRB)', 'БПИФ на гос. облигации (SBGB)', 'БПИФ на облигации в юанях (SBCN'],
				labels: sphereNames,
				datasets: [
					{
						label: "My First Dataset",
						//data: [18, 9, 27, 9, 37],
						data: spherePercent,
						backgroundColor: [gradient1, gradient2, gradient3, gradient4, gradient5],
						hoverOffset: 25,
					},
				],
			},
			options: {
				layout: {
					padding: 10,
				},
				cutout: 80,
				plugins: {
					legend: {
						display: false,
					},
					tooltip: {
						enabled: false,
						// callbacks: {
						// 	label: (context) => {
						// 		return context.label;
						// 	}
						// },
						// yAlign: 'bottom'
					}
				},
				onClick(click, element, chart) {
					if (element[0]) {
						selectedDatasetIndex = element[0].datasetIndex;
						selectedIndex = element[0].index;
						chart.draw();
					}
				},

				onHover(click, element, chart) {
					if (element[0]) {
						selectedDatasetIndex = element[0].datasetIndex;
						selectedIndex = element[0].index;
						addHoverToPart(element[0].index);
						chart.draw();
					} else {
						removePartActive();
					}
				},
			},
			plugins: [
				{
					id: "clickLabel",
					afterDraw: (chart, args, option) => {
						const {
							ctx,
							chartArea: { width, height, top },
						} = chart;

						if (selectedDatasetIndex >= 0) {
							const sum = chart._metasets[selectedDatasetIndex].total;
							const presentValue = chart._metasets[selectedDatasetIndex]._parsed[selectedIndex];
							const percentage = ((presentValue / sum) * 100).toFixed(0);
							const color = chart.data.datasets[selectedDatasetIndex].backgroundColor[selectedIndex];


							ctx.save();
							ctx.font = "bolder 18px SB Sans Display";
							// ctx.fillStyle = color;
							ctx.fillStyle = "#000000";
							ctx.textAlign = "center";
							ctx.textBaseline = "middle";
							ctx.fillText(
								percentage + "%",
								(width + 20) / 2,
								height / 2 + top
							);
							ctx.restore();
						}
					},
				},
			],
		});

		//Ховер по плиткам
		const part = $(".js-item");
		const eventChart = { type: "hover" };

		part.hover(function () {
			const number = $(this).attr('data-number');
			changeBackgroundPercent(number);
			const elem = [{ datasetIndex: 0, index: number }];
			myChart.options.onClick(eventChart, elem, myChart);
			myChart.setActiveElements([{
				datasetIndex: 0,
				index: number,
			}]);
			myChart.tooltip.setActiveElements([{
				datasetIndex: 0,
				index: number,
			}]);

			myChart.update();
		});

		//Выводим цифры первого блока в круговую диграмму
		myChart.options.onClick(eventChart, [{ datasetIndex: 0, index: 0 }], myChart);


		// myChart.setActiveElements([{
		// 	datasetIndex: 0,
		// 	index: 0,
		// }]);

		// myChart.tooltip.setActiveElements([{
		// 	datasetIndex: 0,
		// 	index: 0,
		// }]);

		// myChart.update();
	}

	function addHoverToPart(index) {
		removePartActive();

		// Задаем активной плитке стили
		const part = document.querySelector(`[data-number="${index}"]`);
		const name = part.querySelector('.js-name');
		const percent = part.querySelector('.js-percent');
		const progress = part.querySelector('.js-progress');

		name.classList.add('active');
		percent.classList.add('active');
		progress.classList.add('active');
		part.classList.add('active');

		changeBackgroundPercent(index);
	}

	function removePartActive() {
		const parts = document.querySelectorAll('.js-item');
		parts.forEach((part) => {
			const name = part.querySelector('.js-name');
			const percent = part.querySelector('.js-percent');
			const progress = part.querySelector('.js-progress');

			name.classList.contains('active') && name.classList.remove('active');
			percent.classList.contains('active') && percent.classList.remove('active');
			progress.classList.contains('active') && progress.classList.remove('active');
			part.classList.contains('active') && part.classList.remove('active');
		});
	}

	function changeBackgroundPercent(index) {
		const percentBackground = document.querySelector('.js-percent-back');
		const palette = {
			'0': 'linear-gradient(303.05deg, #FFFF68 5.98%, #2BFC2B 80.29%)',
			'1': 'linear-gradient(256.9deg, #1AC8FF -6.26%, #6CFFF6 90.56%)',
			'2': 'linear-gradient(67.53deg, #FFD057 14.63%, #FF792E 94.5%)',
			'3': 'linear-gradient(90deg, #8AFF92 -11.29%, #61FF39 100%)',
			'4': 'linear-gradient(111.29deg, #87DAFF 14.02%, #5B9DFF 85.98%)',
			'5': 'linear-gradient(67.41deg, #FAED0D -1.26%, #FFAF52 85.31%)',
		}

		percentBackground.style.background = '';
		percentBackground.style.background = palette[index];
	}
});
